// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vxkb","badges":"styles_badges__2e7r1"};